import { Box as MuiBox, BoxProps, TypographyProps, Typography } from '@material-ui/core'
import { PropsWithChildren } from 'react'
import { useTheme } from 'styled-components'

export interface IBoxProps extends BoxProps {
  small?: boolean
  icon?: JSX.Element

  text?: string
  textProps?: TypographyProps
}

export const Pill = ({ small = false, icon, text, textProps, ...rest }: PropsWithChildren<IBoxProps>) => {
  const theme = useTheme()

  return (
    <MuiBox
      bgcolor={theme.colors.supplementary1}
      padding={small ? '0.625rem 0.313rem' : '0.125rem 0.438rem'}
      borderRadius={small ? '6px' : '12px'}
      display={'inline-flex'}
      justifyContent={'center'}
      alignItems={'center'}
      gridGap="0.25rem"
      height={small ? '1.25rem' : '2.188rem'}
      {...rest}
      color={theme.colors.accent1}
    >
      {icon && (
        <MuiBox 
          display="flex" 
          alignItems="center"
          justifyContent="center"
        >
          {icon}
        </MuiBox>
      )}
      
      <Typography variant={small ? "caption" : "overline"} {...textProps}>
        <MuiBox 
        height={small ? '1.25rem' : '2.188rem'}
        display="flex"
        justifyContent="center"
        alignItems="center"
        >
          {text}
        </MuiBox>
      </Typography>
    </MuiBox>
  )
}
